export enum MarpolRegulationEnum {
    Unknown,
    AnnexI,
    AnnexIIChapter17,
    AnnexIIChapter18,
    Gas,
}
